const _ = require('lodash');
const Providers = require('./providers');
const GlobalProperties = require('./global_properties_attached_to_events');
const Config = require('../utils/Config').default;

// Providers that serialize GA4 output (web dataLayer and the ELAL app WebView bridge).
const GA4_PROVIDER_NAMES = ['GoogleTagManager', 'FirebaseMobile'];

function invokeAll(method, ...args) {
    for (const providerName in Providers) {
        const provider = Providers[providerName];
        if (_.isFunction(provider && provider[method])) {
            // check if function exists before call
            try {
                provider[method](...args);
            } catch (_err) {
                // intentionally ignored
            }
        }
    }
}

function startSession(profile, options = {}) {
    invokeAll('startSession', profile, options);
}

function startGtmSession(profile, options = {}) {
    const provider = Providers.GoogleTagManager;
    if (provider && _.isFunction(provider.startSession)) {
        try {
            provider.startSession(profile, options);
        } catch (_err) {
            // intentionally ignored
        }
    }
}

function endSession(profile) {
    invokeAll('endSession', profile);
}

function trackEvent(event, metadata) {
    const properties = Object.assign({}, metadata, GlobalProperties.items());
    if (metadata && metadata.search_token) {
        properties.search_token = metadata.search_token;
    }
    invokeAll('trackEvent', event, properties);
}

// Events added for the ELAL GA4 contract; other brands never sent them, so they stay off their providers.
function trackElalEvent(event, metadata) {
    if (!Config.is_elal) {
        return;
    }
    trackEvent(event, metadata);
}

function trackEventToProviders(providerNames, event, metadata, { includeGlobalProperties = true } = {}) {
    const properties = Object.assign({}, metadata, includeGlobalProperties ? GlobalProperties.items() : {});
    providerNames.forEach((providerName) => {
        const provider = Providers[providerName];
        if (_.isFunction(provider && provider.trackEvent)) {
            try {
                provider.trackEvent(event, properties);
            } catch (_err) {
                // intentionally ignored
            }
        }
    });
}

function trackEventExceptProviders(providerNames, event, metadata) {
    const otherProviderNames = Object.keys(Providers).filter((providerName) => !providerNames.includes(providerName));
    trackEventToProviders(otherProviderNames, event, metadata);
}

function registerSuperProperties(properties) {
    invokeAll('register', properties);
}

module.exports = {
    startSession, // enabling interaction with intercom (chat, analytics) in localhost
    startGtmSession,
    endSession, // enabling interaction with intercom (chat, analytics) in localhost
    trackEvent, // enabling interaction with intercom (chat, analytics) in localhost
    trackElalEvent,
    trackEventToProviders,
    trackEventExceptProviders,
    GA4_PROVIDER_NAMES,
    registerSuperProperties,
    // startSession: (Config.localhost ? (() => { }) : startSession),
    // endSession: (Config.localhost ? (() => { }) : endSession),
    // trackEvent: (Config.localhost ? (() => { }) : trackEvent)
};
